import angular from 'angular';

module.exports = angular.module('market.models.home-condition-report', [])
.factory('HomeConditionReport', function($resource) {
  return $resource('/api/v1/home_condition_reports/:id', { id: '@id' });
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/models/home-condition-report.js
 **/